export const DASHBOARD_PROGRAME = "3";
export const SELF_PACED_PROGRAME = "4";